export const STRIPE_CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      fontFamily: 'Source Code Pro, monospace',
      fontSize: '16px',
      letterSpacing: '0.025em',
      '::placeholder': {
        color: '#aab7c4',
      },
    },
  },
  hidePostalCode: true,
};
